import { Pipe, PipeTransform } from "@angular/core";
import { UPPLM_TRANSLATIONS } from "../constants/upplm.constants.translations";
import { UpsCommonService } from "../services/upplm.common.service";
import { TranslationService } from "../services/upplm.translation.service";

@Pipe({
    name: 'translateData',
    pure: true
})

export class TranslateDataPipe implements PipeTransform {

    constructor(private _translationService: TranslationService,
        private _commonService: UpsCommonService) {
    }
    transform(valueKey: string): string {
        try {
            return this._translationService.translationValues.length > 0 ?
                this._translationService.translationValues.find(x => x.key === valueKey).value :
                UPPLM_TRANSLATIONS.find(x => x.key === valueKey).default;
        } catch (e) {
            console.log('Error translate:' + e);
        }
    }
}